<template>
  <div>
    <div class="topbar">
      <div class="clearfix main-wrap">
        <a class="pull-left img-back" href="javascript:window.history.go(-1)">返回</a>
        <h1>编辑名单</h1>
        <span class="pull-right icon-right blue" style="margin-right:15px;" @click="selectAllOrCancel()">{{selectFlag}}</span>
      </div>
      <div class="liner"></div>
    </div>



    <div class="main-page roll-edit" style="padding-bottom:60px;">
      <div v-for="item in serviceList" v-if="item.list.length > 0">
        <span class="margin-15 block">{{item.typeName ? item.typeName : '未添加托管服务'}}</span>
        <ul class="list-group-item primary">
          <li class="list-group" v-for="student in item.list">
            <div class="liner"></div>
            <a class="group-link clearfix" href="javascript:;">
              <span class="img-wrap small pull-left"><img :src="student.imageAddress ? (item.baseAcessPath + student.imageAddress) : img_default" width="100%"/></span>
              <span class="group-txt" style="padding:0;height:40px;">
                <span class="block overhide">
                  <cite class="font-16 pull-left">{{student.studentName}}</cite>
                  <i class="img-sex" v-bind:class="{'boy': student.sex == '男','girl': student.sex == '女'}">{{student.sex}}</i>
                </span>
                <cite class="gray">{{(student.grade ? student.grade : '') + (student.className ? student.className : '')}}</cite>
              </span>
              <span class="pull-right checkbox-wrap">
                <i class="img-checkbox" @click="student.flag = !student.flag, selectedStudent()" v-bind:class="{'checked': student.flag}"></i>
              </span>
            </a>
          </li>
        </ul>
      </div>

    </div>

    <div class="bottom-bar">
      <a class="button button-block button-primary" @click.prevent="editRoll()">好了，生成名单</a>
    </div>
  </div>
</template>

<script>
import { service } from '../../service'
import { Toast } from 'mint-ui'
export default {
  data () {
    return {
      img_default: require('../../assets/images/img-default.png'),
      cookie_login_data: JSON.parse(window.localStorage['basic_login_data']),
      edit_roll_para: service.setPara('editRoll'),
      get_edit_roll_para: service.setPara('getEditRollList'),
      isHideStep1: false,
      curcheId: 0,
      teacherId: 0,
      serviceList: [],
      studentIdList: [],
      nowStudentIdList: [],
      selectFlag: '全选',
      rollcallId: 0
    }
  },
  mounted: function () {
    this.rollcallId = this.$route.params.rollcallId
    this.getEditRollList()
  },
  methods: {
    nextStep: function () {
      if ($.trim(this.msg) == '') {
        Toast('请填写标题')
        return
      }
      this.isHideStep1 = true
    },
    getEditRollList: function () {
      this.curcheId = this.cookie_login_data.curcheId
      this.teacherId = this.cookie_login_data.teacherId
      this.get_edit_roll_para.curcheId = this.curcheId
      this.get_edit_roll_para.callId = this.rollcallId

      let that = this
      let obj = {context: this, para: this.get_edit_roll_para, successFun: (response) => {
        that.serviceList = response.data.studentList
        that.studentIdList = response.data.studentIdList
        for (var i = 0; i < that.serviceList.length; i++) {
          for (var j = 0; j < that.serviceList[i].list.length; j++) {
            for (var z = 0; z < that.studentIdList.length; z++) {
              if (that.serviceList[i].list[j].studentId == that.studentIdList[z].studentId) {
                that.serviceList[i].list[j].flag = true
              }
            }
          }
        }
      }}
      service.request(obj)
    },
    selectAllOrCancel: function () { // 全选，取消全选
      for (var i = 0; i < this.serviceList.length; i++) {
        var studentList = this.serviceList[i].list
        for (var j = 0; j < studentList.length; j++) {
          if (this.selectFlag == '全选') {
            studentList[j].flag = true
          } else {
            studentList[j].flag = false
          }
        }
      }
      if (this.selectFlag == '全选') {
        this.selectFlag = '取消全选'
      } else {
        this.selectFlag = '全选'
      }
    },
    selectedStudent: function () {
      var flag = false
      for (var i = 0; i < this.serviceList.length; i++) {
        var studentList = this.serviceList[i].list
        for (var j = 0; j < studentList.length; j++) {
          if (!studentList[j].flag) {
            this.selectFlag = '全选'
            flag = true
            break
          }
        }
      }
      if (!flag) {
        this.selectFlag = '取消全选'
      }
    },
    editRoll: function () {
      this.nowStudentIdList = []
      if ($('.img-checkbox.checked').length === 0) {
        Toast('请添加学生')
        return
      } else {
        for (var i = 0; i < this.serviceList.length; i++) {
          var studentList = this.serviceList[i].list
          for (var j = 0; j < studentList.length; j++) {
            if (studentList[j].flag) {
              this.nowStudentIdList.push(studentList[j].studentId)
            }
          }
        }
      }

      var oldStudentIdList = []
      for (var z = 0; z < this.studentIdList.length; z++) {
        oldStudentIdList.push(this.studentIdList[z].studentId)
      }
      this.edit_roll_para.nowStudentIdList = JSON.stringify(this.nowStudentIdList)
      this.edit_roll_para.oldStudentIdList = JSON.stringify(oldStudentIdList)
      this.edit_roll_para.callId = this.rollcallId
      this.edit_roll_para.curcheId = this.curcheId

      let obj = {context: this, para: this.edit_roll_para, successFun: (response) => {
        Toast('编辑成功')
        window.history.go(-1)
      }}
      service.request(obj)
    }
  }
}
</script>



// WEBPACK FOOTER //
// rollcallEdit.vue?26c90e50